export const SCOPE = 'bbraunSharedUiDiscardChanges';
